import { CssBaseline, makeStyles, Typography, List, ListItem, Box, TextField, MenuItem } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import axios from 'axios';
import { admin as v_admin, basic, Values } from '../../request/values';
import { useCookies } from 'react-cookie';
import { SubAdminHeaderBar } from '../../shared/header/HeaderBar';

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
	},
	mainPage: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5vh',
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		paddingBottom: '0.5vh',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	form: {
		display: 'flex',
		width: '97%',
		height: '5%',
		justifyContent: 'right',
		alignItems: 'center',
		gap: '1%',
		'& input': {
			width: '15%',
			height: '80%',
			paddingLeft: '7px',
		},
		'& Button': {
			border: 'solid gray 1px',
			height: '90%',
		},
	},
	classList: {
		'& #classOpen': {
			float: 'right',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
		'& #logout': {
			float: 'left',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		height: '60vh',
		margin: '1% 3%',
		borderBottom: '2px solid black',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '3fr 3fr 3fr 2fr 2fr 17px',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid gray',
			borderWidth: '0 0 1px 0',
		},
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '3fr 3fr 3fr 2fr 2fr 17px',
		padding: '25px 0',
		backgroundColor: `${COLORS.WHITE}`,
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: 'none',
		fontSize: '1rem',
		fontFamily: 'NanumB',
		lineHeight: '21px',
		bolderWidth: '1px',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
	selectField: {
		marginLeft: '70%',
		width: '20%',
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(2),
	},
	selectRoot: {
		'& .MuiFormLabel-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiSelect-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 12,
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#cfd4d9',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
			borderWidth: 2,
		},
	},
	selectLabel: {
		backgroundColor: '#fff',
		padding: '0 4px',
	},
	menuPaper: {
		borderRadius: 12,
		boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
		marginTop: 8,
	},
	menuItem: {
		...theme.typography.body1,
		padding: theme.spacing(1.25, 1.5),
		'&:not(:last-child)': {
			borderBottom: '1px solid #f1f3f5',
		},
	},
}));

type iClassList = {
	class_code: string;
	class_name: string;
	class_country: string;
	start_date: string;
	class_version: string;
	reg_date: string;
};

const SERVER = basic.server;

const SubAdminClassList2: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();

	const { member } = props;

	const [ClassList, setClassList] = useState<iClassList[]>([]);
	const [affiliation, setAffiliation] = useState<string>('all');
	const getClassContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.class_list2);
		let params = { id: member.id.toString() };
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.class_list,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
			});
	};

	useEffect(() => {
		getClassContent();
	}, []);

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<SubAdminHeaderBar />
					<TextField
						className={`${classes.selectField} ${classes.selectRoot}`}
						//variant="outlined"
						label="소속 선택"
						select
						fullWidth
						value={affiliation}
						InputLabelProps={{ shrink: true, className: classes.selectLabel }}
						onChange={(e) => setAffiliation((e.target as HTMLInputElement).value)}
						SelectProps={{
							MenuProps: {
								getContentAnchorEl: null,
								anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
								transformOrigin: { vertical: 'top', horizontal: 'left' },
								classes: { paper: classes.menuPaper },
							},
						}}
					>
						<MenuItem className={classes.menuItem} value="all">
							전체
						</MenuItem>
						<MenuItem className={classes.menuItem} value="유스타터">
							유스타터
						</MenuItem>
						<MenuItem className={classes.menuItem} value="대구행복한미래재단">
							대구행복한미래재단
						</MenuItem>
						<MenuItem className={classes.menuItem} value="교사">
							교사
						</MenuItem>
						<MenuItem className={classes.menuItem} value="null">
							무소속
						</MenuItem>
					</TextField>
					<div className={classes.classList}>
						<div className={classes.table}>
							<div id="title">
								<span>
									<Typography>교육 날짜</Typography>
								</span>
								<span>
									<Typography>강사명</Typography>
								</span>
								<span>
									<Typography>클래스 코드</Typography>
								</span>
								<span>
									<Typography>클래스 버전</Typography>
								</span>
								<span>
									<Typography>참가 인원</Typography>
								</span>
							</div>
							<List id="classinfo">
								{ClassList != null &&
									ClassList.map((item: any, index: number) => {
										if (affiliation === 'all') {
											return (
												<AppListItem
													index={index}
													code={item.class_code}
													name={item.name}
													version={item.class_version}
													//place={item.class_country}
													participant={item.participant}
													date={item.reg_date}
												/>
											);
										} else if (affiliation === 'null') {
											if (item.affiliation === null) {
												return (
													<AppListItem
														index={index}
														code={item.class_code}
														name={item.name}
														version={item.class_version}
														//place={item.class_country}
														participant={item.participant}
														date={item.reg_date}
													/>
												);
											}
										} else if (item.affiliation === affiliation) {
											return (
												<AppListItem
													index={index}
													code={item.class_code}
													name={item.name}
													version={item.class_version}
													//place={item.class_country}
													participant={item.participant}
													date={item.reg_date}
												/>
											);
										}
									})}
								<div className={classes.blank}></div>
							</List>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, code, name, version, participant, date } = props;

	return (
		<ListItem id={index} className={classes.classInfo}>
			{/* <Box className={classes.buttonLabel}>{startDate}</Box> */}
			<Box className={classes.buttonLabel}>{date.toString().slice(0, 10)}</Box>
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{code}</Box>
			<Box className={classes.buttonLabel}>{version}</Box>
			<Box className={classes.buttonLabel}>{participant}</Box>
		</ListItem>
	);
};

export default SubAdminClassList2;
